module.exports = __webpack_public_path__ + "img/close.05ee6309.svg";